define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/Attribute",
	"csi/heading/BooleanController"
], function(declare,csi,Attribute,BooleanController) {

	return declare(BooleanController, {
		_toWriterValue: function(/*String*/id, /*String*/type) {
        	// summary: convert boolean newValue into ref to node in context (either view node for property view, or row node for table)
        	this.oldValue = Attribute.prototype._getValue.call(this.ren, this._ctx, this.heading);
       		this.newValue = this.newValue ? this._ctx.getNodeContext().$URL : csi.EMPTY_URL;
        	this.inherited(arguments);
        },

        postProcessSuccess: function() {
			// summary: refresh column in table to clear previous selection
			if (this.newValue != csi.EMPTY_URL) {
				var	oldRefNode = this.widget.getRefNodeByUrl(this.oldValue);
				if (oldRefNode) {
					this.widget.redrawNode(oldRefNode);
				}
			}

			this.inherited(arguments);
		}
	});
});